import { styled } from '@mui/material/styles';
import { Grid, TextField } from '@mui/material';

export const MentionContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  width: '100%',
}));

export const Input = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    color: '#fff',
    '&:hover': {
      border: '1px solid rgba(255, 255, 255, 0.3)',
    },
    '& fieldset': {
      border: 'none',
    },
    '& input': {
      color: '#fff',
      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,
      },
    },
    '& textarea': {
      color: '#fff',
      '&::placeholder': {
        color: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,
      },
    },
  },
  '& .MuiFormHelperText-root': {
    color: '#f44336',
  },
}));

export const MentionMenu = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: 'rgba(30, 30, 30, 0.95)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '8px',
  maxHeight: '200px',
  overflowY: 'auto',
  zIndex: 1000,
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
  backdropFilter: 'blur(10px)',
  marginTop: '4px',
}));

export const MentionGroupTitle = styled('div')(({ theme }) => ({
  padding: '8px 12px',
  fontSize: '12px',
  fontWeight: '600',
  color: 'rgba(255, 255, 255, 0.7)',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
}));

export const MentionItem = styled('div')(({ theme }) => ({
  padding: '8px 12px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  color: '#fff',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  '&:last-child': {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
  },
}));

export const MentionName = styled('span')(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '500',
  color: '#fff',
}));

 